<div class="home" data-testid="somaliland-home-container">
  <div class="body">
    <img src="/assets/images/somaliland/somaliland-logo.png" width="400px">
    <div class="help-banner">
      <h4>{{ 'home.questions-1' | translate }}</h4>
      <p>{{ 'home.questions-2' | translate }}</p>
    </div>
  </div>
</div>
